<section class="banner-section">
    <div class="banner-dom">
        <div class="carousel-container position-relative">
            <ngb-carousel [interval]="0" [arrows]="false" [pauseOnHover]="false" [pauseOnFocus]="false" [wrap]="false"
                [showNavigationIndicators]="false" [showNavigationArrows]="false">
                <ng-template ngbSlide *ngFor="let slide of bannerImages">
                    <div class="image-watermark-wrapper">
                        <img [src]="helper.getImageSrc(slide)" class="d-block w-100 banner-img" alt="banner"
                            (error)="handleBannerError($event)">
                    </div>
                </ng-template>
            </ngb-carousel>
        </div>
    </div>
</section>

<section class="feature_section">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-6 col-lg-3 mb-3">
                <div class="d-flex">
                    <div class="icon">
                        <i class="pe-7s-diamond"></i>
                    </div>
                    <div class="details ps-3">
                        <h6 class="mb-2 truncate-line-2">{{ "label-title.wide-range-categories" | translate }}</h6>
                        <p class="truncate-line-4">{{ "paragraph-title.explore-jewelry-categories-para" | translate }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-3 mb-3">
                <div class="d-flex">
                    <div class="icon">
                        <i class="pe-7s-gift"></i>
                    </div>
                    <div class="details ps-3">
                        <h6 class="mb-2 truncate-line-2">{{ "label-title.exclusive-designs" | translate }}</h6>
                        <p class="truncate-line-4">{{ "paragraph-title.unique-affordable-designs-para" | translate }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-3 mb-3">
                <div class="d-flex">
                    <div class="icon">
                        <i class="pe-7s-check"></i>
                    </div>
                    <div class="details ps-3">
                        <h6 class="mb-2 truncate-line-2">{{ "label-title.quality-assurance" | translate }}</h6>
                        <p class="truncate-line-4">{{ "paragraph-title.precision-and-durability-para" | translate }}</p>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-3 mb-3">
                <div class="d-flex">
                    <div class="icon">
                        <i class="pe-7s-help2">pe-7s-help2</i>
                    </div>
                    <div class="details ps-3">
                        <h6 class="mb-2 truncate-line-2">{{"label-title.support-24" | translate}} </h6>
                        <p class="truncate-line-4"> {{"label-title.contact-us-24-para" | translate}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="type_section">
    <div class="container">
        <div class="row type_row">
            <div class="col-sm-6 position-relative">
                <img src="../../../assets/img/home-page/IMG_0405.JPG" class="w-100 type_img" alt="Wedding Rings">
            </div>
            <div class="col-sm-6 position-relative">
                <img src="../../../assets/img/home-page/IMG_0399.JPG" class="w-100 type_img" alt="Floral Earrings">
            </div>
        </div>
    </div>
</section>

<!-- <div class="new_arrival">
    <div class="container">
        <div class="text-center heading-title">
            <h3>{{ "heading-title.new-arrivals" | translate}}</h3>
            <p> {{"label-title.add-new-arrivals-to-weekly-lineup" | translate}}</p>
        </div>
        <div class="arrivals custome-nav">
            <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
                <li [ngbNavItem]="1">
                    <button ngbNavLink>Bracelets</button>
                    <ng-template ngbNavContent>
                        <div class="arrrival_items">
                            <div class="row">
                                <div class="col-3">
                                    <div class="card">
                                        <div class="card-image">
                                            <img src="../../../assets/img/home-page/item1.jpg" alt="">
                                            <div class="icons">
                                                <a href="javascript:;" class="heart"></a>
                                                <a href="javascript:;" class="revers"></a>
                                                <a href="javascript:;" class="search"></a>
                                            </div>
                                            <div class="buttons">
                                                <button class="btn_1 btn_seondary">Add To card</button>
                                            </div>
                                        </div>
                                        <div class="card-body text-center">
                                            <p class="mb-1">Chatelaine , Necklaces</p>
                                            <h6>Diamond Band Ring</h6>
                                            <p class="price">$100.00</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="card">
                                        <div class="card-image">
                                            <img src="../../../assets/img/home-page/item2.jpg" alt="">
                                            <div class="icons">
                                                <a href="javascript:;" class="heart"></a>
                                                <a href="javascript:;" class="revers"></a>
                                                <a href="javascript:;" class="search"></a>
                                            </div>
                                            <div class="buttons">
                                                <button class="btn_1 btn_seondary">Add To card</button>
                                            </div>
                                        </div>
                                        <div class="card-body text-center">
                                            <p class="mb-1">Brooches , Flatware</p>
                                            <h6>Diamond Band Ring</h6>
                                            <p class="price">$86.00</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="card">
                                        <div class="card-image">
                                            <img src="../../../assets/img/home-page/item3.jpg" alt="">
                                            <div class="icons">
                                                <a href="javascript:;" class="heart"></a>
                                                <a href="javascript:;" class="revers"></a>
                                                <a href="javascript:;" class="search"></a>
                                            </div>
                                            <div class="buttons">
                                                <button class="btn_1 btn_seondary">Add To card</button>
                                            </div>
                                        </div>
                                        <div class="card-body text-center">
                                            <p class="mb-1">Necklaces, Runners</p>
                                            <h6>Dissent Collar Earring</h6>
                                            <p class="price">$95.00</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="card">
                                        <div class="card-image">
                                            <img src="../../../assets/img/home-page/item4.jpg" alt="">
                                            <div class="icons">
                                                <a href="javascript:;" class="heart"></a>
                                                <a href="javascript:;" class="revers"></a>
                                                <a href="javascript:;" class="search"></a>
                                            </div>
                                            <div class="buttons">
                                                <button class="btn_1 btn_seondary">Add To card</button>
                                            </div>
                                        </div>
                                        <div class="card-body text-center">
                                            <p class="mb-1">Necklaces, Tiara</p>
                                            <h6>Long Earrings Women</h6>
                                            <p class="price">$70.00</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </li>
                <li [ngbNavItem]="2">
                    <button ngbNavLink>Earrings</button>
                    <ng-template ngbNavContent>
                        <div class="arrrival_items">
                            <div class="row">
                                <div class="col-3">
                                    <div class="card">
                                        <div class="card-image">
                                            <img src="../../../assets/img/home-page/item1.jpg" alt="">
                                        </div>
                                        <div class="card-body text-center">
                                            <p class="mb-1">Chatelaine , Necklaces</p>
                                            <h6>Diamond Band Ring</h6>
                                            <p class="price">$100.00</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="card">
                                        <div class="card-image">
                                            <img src="../../../assets/img/home-page/item2.jpg" alt="">
                                        </div>
                                        <div class="card-body text-center">
                                            <p class="mb-1">Brooches , Flatware</p>
                                            <h6>Diamond Band Ring</h6>
                                            <p class="price">$86.00</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="card">
                                        <div class="card-image">
                                            <img src="../../../assets/img/home-page/item3.jpg" alt="">
                                        </div>
                                        <div class="card-body text-center">
                                            <p class="mb-1">Necklaces, Runners</p>
                                            <h6>Dissent Collar Earring</h6>
                                            <p class="price">$95.00</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="card">
                                        <div class="card-image">
                                            <img src="../../../assets/img/home-page/item4.jpg" alt="">
                                        </div>
                                        <div class="card-body text-center">
                                            <p class="mb-1">Necklaces, Tiara</p>
                                            <h6>Long Earrings Women</h6>
                                            <p class="price">$70.00</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </li>
                <li [ngbNavItem]="3">
                    <button ngbNavLink>Necklaces</button>
                    <ng-template ngbNavContent>
                        <div class="arrrival_items">
                            <div class="row">
                                <div class="col-3">
                                    <div class="card">
                                        <div class="card-image">
                                            <img src="../../../assets/img/home-page/item1.jpg" alt="">
                                        </div>
                                        <div class="card-body text-center">
                                            <p class="mb-1">Chatelaine , Necklaces</p>
                                            <h6>Diamond Band Ring</h6>
                                            <p class="price">$100.00</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="card">
                                        <div class="card-image">
                                            <img src="../../../assets/img/home-page/item2.jpg" alt="">
                                        </div>
                                        <div class="card-body text-center">
                                            <p class="mb-1">Brooches , Flatware</p>
                                            <h6>Diamond Band Ring</h6>
                                            <p class="price">$86.00</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="card">
                                        <div class="card-image">
                                            <img src="../../../assets/img/home-page/item3.jpg" alt="">
                                        </div>
                                        <div class="card-body text-center">
                                            <p class="mb-1">Necklaces, Runners</p>
                                            <h6>Dissent Collar Earring</h6>
                                            <p class="price">$95.00</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="card">
                                        <div class="card-image">
                                            <img src="../../../assets/img/home-page/item4.jpg" alt="">
                                        </div>
                                        <div class="card-body text-center">
                                            <p class="mb-1">Necklaces, Tiara</p>
                                            <h6>Long Earrings Women</h6>
                                            <p class="price">$70.00</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </li>
            </ul>

            <div [ngbNavOutlet]="nav" class="mt-2"></div>
        </div>
    </div>
</div> -->

<div class="category-slider">
    <div class="container-xxl">
        <div class="text-center heading-title mb-4">
            <h3>{{"heading-title.our-categories" | translate}}</h3>
            <div class="w-100 d-flex justify-content-center my-2">
                <ng-select class="category-selection-width" id="product-publish-tag" #agreeSelect
                    placeholder="{{ 'label-title.search-category' | translate }}" [searchable]="true" [clearable]="false"
                    (change)="selectCategoryWiseProductList($event)">
                    @for(category of categoryList; track $index) {
                    <ng-option [value]="category"> {{ category.name }}</ng-option>
                    }
                </ng-select>
            </div>
        </div>

        <swiper-container class="jewelry-swiper" [spaceBetween]="20" [slidesPerView]="4" [breakpoints]="breakpoints"
            (slideChange)="onSlideChange($event)">
            <swiper-slide *ngFor="let item of categoryList">
                <div class="category-item" (click)="selectCategoryWiseProductList(item)">
                    <div class="category-image image-watermark-wrapper">
                        <img [src]="helper.getImageSrc(item.images?.[0], helper.DEFAULT_LOGO)" [alt]="item.name" class="jewelry-image"
                            (error)="helper.handleProductImageError($event)" />
                    </div>
                    <div class="item-name mt-2">
                        <h6 class="jewelry-title">{{ item.name }}</h6>
                    </div>
                </div>
            </swiper-slide>
        </swiper-container>
        <!-- Custom Arrows -->
        <button class="swiper-button-prev-btn" (click)="goPrev()"></button>
        <button class="swiper-button-next-btn" (click)="goNext()"></button>
    </div>
</div>

<!-- product list code commented becuase without login not show list -->
<!-- <div class="products">
    <div class="container">
        <div class="text-center heading-title mb-4">
            <h3>{{"heading-title.our-products" | translate}} </h3>
        </div>
        <div class="arrrival_items">
            <div class="row">
                @for(product of productList; track $index) {
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                        <div class="card">
                            <div class="card-image product-dual-img image-watermark-wrapper" (mouseenter)="onHover(product)" (mouseleave)="onHoverOut()">
                            <img class="watermark-main-image" [src]="helper.getImageSrc(hoveredProductId === product._id && product.images?.[0] ? product.images[0] : product.profileImage, helper.DEFAULT_LOGO)" [alt]="product.name || 'KB Imitation jewellery'"
                                (error)="helper.handleProductImageError($event)" [class.animate]="hoveredProductId === product._id"/>
                            <div class="buttons">
                                <button class="btn_1 btn_seondary btn-view"
                                    (click)="viewProduct(product)">{{"button-title.view" | translate}}</button>
                            </div>
                            <span class="onsale" *ngIf="product.tags">{{product.tags}}</span>
                        </div>
                        <div class="card-body text-center">
                            <h6 class="truncate-line-2"><a [routerLink]="['/app/product-detail', product._id]">{{product.name || '-'}}</a></h6>
                            <p class="price">{{helper.currency}} {{product.price}}</p>
                            <p class="price">{{"label-title.quantity" | translate}} : {{product.quantity}}</p>
                        </div>
                    </div>
                </div>
                }@empty {
                <div class="col-12 d-flex justify-content-center align-items-center py-5">
                    <p>{{'label-title.no-data-found' | translate}}</p>
                </div>
                }
            </div>
            <div class="text-center mt-2" *ngIf="productList.length < totalProducts">
                <a href="javascript:void(0)" class="load-more-link"
                    (click)="loadMoreProducts()">{{"label-title.load-more" | translate}}</a>
            </div>

        </div>
    </div>
</div> -->

<!-- review section hide for now -->
<!-- <div class="client-review">
    <div class="container">
        <div class="text-center heading-title mb-4">
            <h3>{{"heading-title.customer-reviews" | translate}} </h3>
            <p>{{"label-title.what-our-customer-say-review" | translate}}</p>
        </div>
        <div class="carousel-container pt-2">
            <div class="carousel-container text-center">
                <ngb-carousel [interval]="5000" [pauseOnHover]="false" [pauseOnFocus]="false" [wrap]="true"
                    [showNavigationIndicators]="false" [showNavigationArrows]="false">

                    <ng-template ngbSlide>
                        <div class="item">
                            <p class="mb-2">{{"paragraph-title.review-para-1" | translate}}</p>
                        </div>
                    </ng-template>
                    <ng-template ngbSlide>
                        <div class="item">
                            <p class="mb-2">{{"paragraph-title.review-para-2" | translate}} </p>
                        </div>
                    </ng-template>
                    <ng-template ngbSlide>
                        <div class="item">
                            <p class="mb-2">{{"paragraph-title.review-para-3" | translate}}</p>
                        </div>
                    </ng-template>
                    <ng-template ngbSlide>
                        <div class="item">
                            <p class="mb-2">{{"paragraph-title.review-para-4" | translate}} </p>
                        </div>
                    </ng-template>
                    <ng-template ngbSlide>
                        <div class="item">
                            <p class="mb-2">{{"paragraph-title.review-para-5" | translate}}</p>
                        </div>
                    </ng-template>
                </ngb-carousel>
            </div>
        </div>
    </div>
</div> -->


<app-auth #authModel></app-auth>

<div>
    <lightgallery [settings]="settings" [onInit]="onInit"> </lightgallery>
</div>

<app-product-detail-modal #productDetailModal></app-product-detail-modal>
